import { v4 as uuidv4 } from "uuid";
import userImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/user_1_image_placeholder.png";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createUserCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers";
import {
  createH5Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getMarginOptions,
  getPaddingOptions,
} from "@circle-react-shared/BuilderUI/utils/boxModelStyleHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";
import { getSizingOptions } from "../../../utils/sizeStyleHelpers";
import { createImageBlock } from "../../utils/mediaBlockHelpers";
import imagePlaceholder1 from "./image_placeholder_1.png";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "BlogListingItemBlock",
  props: {
    image: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          placeholder: imagePlaceholder1,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "100%",
                height: "12.5rem",
                minHeight: "none",
                maxHeight: "none",
                minWidth: "none",
                maxWidth: "auto",
              },
            }),
          },
        }),
      ],
    },
    userCard: {
      prop: "children",
      type: "children",
      value: [
        createUserCardBlock({
          image: {
            signedId: "",
            placeholder: userImagePlaceholder,
          },
          header: "James Carter",
          description: "Business growth coach",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "Apr 11, 2025 · Member experience",
          paragraphStyle: "p3",
        }),
        createH5Block({
          text: "Designing your first member experience flow",
        }),
        createPBlock({
          text: "Learn how to build a seamless onboarding journey that welcomes, guides, and activates new members with clarity and intent.",
          paragraphStyle: "p3",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        backgroundColor: getBackgroundColorOptions({
          defaultValue: "0",
        }),
        padding: getPaddingOptions({
          defaultValue: {
            paddingBottom: "0",
            paddingLeft: "0",
            paddingRight: "0",
            paddingTop: "0",
          },
        }),
        margin: getMarginOptions({
          defaultValue: {
            marginBottom: "0",
            marginLeft: "0",
            marginRight: "0",
            marginTop: "0",
          },
        }),
      },
    },
  },
};

export const createBlogListingItemBlock = ({
  image = { signedId: "", placeholder: "" },
  userCard = {
    image: { signedId: "", placeholder: "" },
    header: "",
    description: "",
  },
  header = "",
  title = "",
  description = "",
  content = [],
}: {
  image?: { signedId: string; placeholder?: string };
  userCard?: {
    image: { signedId: string; placeholder?: string };
    header: string;
    description: string;
  };
  header?: string;
  title?: string;
  description?: string;
  content?: BaseBlock[];
}): BaseBlock => ({
  ...defaultData,
  id: uuidv4(),
  props: {
    ...defaultData.props,
    image: {
      ...defaultData.props.image,
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: image.signedId,
          placeholder: image.placeholder,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "100%",
                height: "12.5rem",
                minWidth: "none",
                minHeight: "none",
                maxWidth: "none",
                maxHeight: "none",
              },
            }),
          },
        }),
      ],
    },
    userCard: {
      ...defaultData.props.userCard,
      prop: "children",
      type: "children",
      value: [
        createUserCardBlock({
          image: userCard.image,
          header: userCard.header,
          description: userCard.description,
          size: "small",
        }),
      ],
    },
    content: {
      ...defaultData.props.content,
      prop: "children",
      type: "children",
      value:
        content && content.length > 0
          ? content
          : [
              createPBlock({
                text: header,
                paragraphStyle: "p3",
              }),
              createH5Block({
                text: title,
              }),
              createPBlock({
                text: description,
                paragraphStyle: "p3",
              }),
            ],
    },
  },
});
